/**
 * StarVie-only stock override.
 *
 * When a StarVie product has its admin "Availability Source" set to
 * "Noliktavā Baltijā" (`europe`), the product stays purchasable and is shown
 * as available even if all stock columns are 0.
 *
 * This override is intentionally scoped to StarVie + `europe` only — every
 * other brand and every other availability source keeps its existing logic.
 */

/** Virtual quantity exposed for overridden StarVie products. */
export const STARVIE_BALTICS_VIRTUAL_QTY = 99;

export function isStarvieBrand(brand?: string | null): boolean {
  return (brand ?? "").trim().toLowerCase() === "starvie";
}

export function hasStarvieBalticsOverride(
  brand?: string | null,
  availabilitySource?: string | null
): boolean {
  return isStarvieBrand(brand) && availabilitySource === "europe";
}
